import { render } from "./OilReminderClients.vue?vue&type=template&id=cc36bbce"
import script from "./OilReminderClients.vue?vue&type=script&lang=js"
export * from "./OilReminderClients.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__